import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.includes.js";
// Utils
import cookies from "../../cookies/cookies";
import session from "../../session/session.utils";
// Constants
import cookiesConstants from "../../../constants/storage";
// Types

var mockRegisterTrace = function mockRegisterTrace(sessionId, actionCode, operationError, errorMessage, obj) {
  window.console.log('registerTrace called - Mock function', {
    sessionId: sessionId,
    actionCode: actionCode,
    operationError: operationError,
    errorMessage: errorMessage,
    obj: obj
  });
};
var mockAssistedAuthenticateSuccess = function mockAssistedAuthenticateSuccess(sessionId, accessToken, refreshToken, role) {
  window.console.log('assistedAuthenticateSuccess called - Mock function', {
    sessionId: sessionId,
    accessToken: accessToken,
    refreshToken: refreshToken,
    role: role
  });
};
var mockGetAgentAccessToken = function mockGetAgentAccessToken(sessionId) {
  window.console.log('getAgentAccessToken called - Mock function', {
    sessionId: sessionId
  });
};
var mockOnLogoutSuccess = function mockOnLogoutSuccess(sessionId) {
  window.console.log('onLogoutSuccess called - Mock function', {
    sessionId: sessionId
  });
};
var mockRaiseN2InIvr = function mockRaiseN2InIvr(signatureKeyPositions, progressId) {
  window.console.log('raiseN2InIvr called - Mock function', {
    signatureKeyPositions: signatureKeyPositions,
    progressId: progressId
  });
};
var mockOnInvalidSession = function mockOnInvalidSession(sessionId) {
  window.console.log('onInvalidSession called - Mock function', {
    sessionId: sessionId
  });
};
var mockOnExpiredSignatureKey = function mockOnExpiredSignatureKey(sessionId) {
  window.console.log('onExpiredSignatureKey called - Mock function', {
    sessionId: sessionId
  });
};
var agentToken, country, email, userName, firstName, lastName, interactionId, accessToken, refreshToken, sessionId, documentType, _registerTrace, _assistedAuthenticateSuccess, _getAgentAccessToken, _onLogoutSuccess, _raiseN2InIvr, _onInvalidSession, _onExpiredSignatureKey, platform, phoneProvided;
var agentTokenRequestPromise;
var getDomainFromHostname = function getDomainFromHostname() {
  return window.location.hostname.split('.cc')[1] || 'zinia.com';
};
var getCurrentDomain = function getCurrentDomain() {
  var _window$location, _window$location$host;
  return (_window$location = window.location) !== null && _window$location !== void 0 && (_window$location$host = _window$location.hostname) !== null && _window$location$host !== void 0 && _window$location$host.includes('localhost') ? '' : getDomainFromHostname();
};
var setupUsdCore = function setupUsdCore() {
  var currentDomain = getCurrentDomain();
  window.USD = {
    init: function init() {
      var _usdInformation$count, _country;
      var usdInformation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      agentToken = usdInformation.agentToken;
      accessToken = usdInformation.securitySSR_AccessToken;
      refreshToken = usdInformation.securitySSR_RefreshToken;
      email = usdInformation.email;
      documentType = usdInformation.documentType;
      sessionId = usdInformation.sessionId;
      interactionId = usdInformation.interactionId;
      platform = usdInformation.platform || 'CC';
      firstName = usdInformation.firstName || '';
      lastName = usdInformation.lastName || '';
      country = (_usdInformation$count = usdInformation.country) === null || _usdInformation$count === void 0 ? void 0 : _usdInformation$count.toLowerCase();
      userName = usdInformation.userName;
      _registerTrace = usdInformation.RegisterTrace || mockRegisterTrace;
      _assistedAuthenticateSuccess = usdInformation.AssistedAuthenticateSuccess || mockAssistedAuthenticateSuccess;
      _getAgentAccessToken = usdInformation.GetAgentAccessToken || mockGetAgentAccessToken;
      _onLogoutSuccess = usdInformation.OnLogoutSuccess || mockOnLogoutSuccess;
      _raiseN2InIvr = usdInformation.RaiseN2InIvr || mockRaiseN2InIvr;
      _onInvalidSession = usdInformation.OnInvalidSession || mockOnInvalidSession;
      _onExpiredSignatureKey = usdInformation.SignatureKeyExpired || mockOnExpiredSignatureKey;
      agentToken && cookies.setCookie({
        name: 'agentToken',
        value: agentToken,
        domain: currentDomain
      });
      accessToken && cookies.setCookie({
        name: 'accessToken',
        value: accessToken,
        domain: currentDomain
      });
      refreshToken && cookies.setCookie({
        name: 'refreshToken',
        value: refreshToken,
        domain: currentDomain
      });
      country && localStorage.setItem('language', (_country = country) === null || _country === void 0 ? void 0 : _country.toLowerCase());
      if (usdInformation.userName) {
        userName && cookies.setCookie({
          name: cookiesConstants.LOCALSTORAGE_IDS.USERNAME,
          value: userName,
          domain: currentDomain
        });
        localStorage.setItem(cookiesConstants.LOCALSTORAGE_IDS.USERNAME, userName);
        phoneProvided = true;
      }
    },
    getDocumentType: function getDocumentType() {
      return documentType;
    },
    getAgentToken: function getAgentToken() {
      return agentToken;
    },
    getUserName: function getUserName() {
      return userName;
    },
    getUserNameProvided: function getUserNameProvided() {
      return phoneProvided;
    },
    getUserFirstName: function getUserFirstName() {
      return firstName;
    },
    getUserLastName: function getUserLastName() {
      return lastName;
    },
    getEmail: function getEmail() {
      return email;
    },
    getInteractionId: function getInteractionId() {
      return interactionId;
    },
    getSessionId: function getSessionId() {
      return sessionId;
    },
    getPlatform: function getPlatform() {
      return platform;
    },
    getCountry: function getCountry() {
      return country;
    },
    registerTrace: function registerTrace(_ref) {
      var actionCode = _ref.actionCode,
        operationError = _ref.operationError,
        errorMessage = _ref.errorMessage,
        obj = _ref.obj;
      return _registerTrace(sessionId, actionCode, operationError, errorMessage, obj);
    },
    assistedAuthenticateSuccess: function assistedAuthenticateSuccess(accessToken, refreshToken, role) {
      _assistedAuthenticateSuccess(sessionId, accessToken, refreshToken, role);
    },
    raiseN2InIvr: function raiseN2InIvr(signatureKeyPositions, progressId) {
      _raiseN2InIvr(signatureKeyPositions, progressId);
    },
    onLogoutSuccess: function onLogoutSuccess() {
      _onLogoutSuccess(sessionId);
    },
    onInvalidSession: function onInvalidSession(sessionId) {
      /**  To be used when there is not way to continue the session:
       * - No tokens
       * - Can't refresh agent token
       */
      _onInvalidSession(sessionId);
    },
    onExpiredSignatureKey: function onExpiredSignatureKey(sessionId) {
      _onExpiredSignatureKey(sessionId);
    },
    getAgentAccessToken: function getAgentAccessToken() {
      return new Promise(function (resolve, reject) {
        agentTokenRequestPromise = {
          resolve: resolve,
          reject: reject
        };
        window.console.log('USD - Agent AT - Requested');
        _getAgentAccessToken(sessionId);
      });
    },
    refreshAgentToken: function refreshAgentToken(agentAccessToken) {
      window.console.log('USD - Agent AT - Received: ', agentAccessToken);
      if (agentAccessToken) {
        var _agentTokenRequestPro, _agentTokenRequestPro2;
        cookies.setCookie({
          name: cookiesConstants.COOKIES_IDS.AGENT_TOKEN,
          value: agentAccessToken,
          domain: currentDomain
        });
        (_agentTokenRequestPro = (_agentTokenRequestPro2 = agentTokenRequestPromise).resolve) === null || _agentTokenRequestPro === void 0 ? void 0 : _agentTokenRequestPro.call(_agentTokenRequestPro2, agentAccessToken);
      } else {
        session.clearSessionData();
        _onInvalidSession(sessionId);
      }
    }
    // resetClient: () => {
    //   userName = '';
    //   interactionId = '';
    //   accessToken = '';
    //   refreshToken = '';
    //   sessionId = '';
    // },
  };
};
export default setupUsdCore;